import { useEffect, useState } from "react";
import sport from '../../assets/image.png'
export default function AuthRightSection() {
    const [currentImage, setCurrentImage] = useState(0);

    const images = [
        "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=1000&fit=crop",
        "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=800&h=1000&fit=crop",
        "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=800&h=1000&fit=crop",
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]);



    return (
        <div className="hidden md:flex w-1/2 bg-gradient-to-r from-[#057BB5] to-[#2BACE2] items-center justify-center relative overflow-hidden">
            <div className="absolute top-10 right-10 w-32 h-32 bg-white/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 left-20 w-40 h-40 bg-[#2BACE2]/10 rounded-full blur-3xl"></div>

            <div className="relative w-full flex items-center justify-center p-6">
                <img
                    // src={images[currentImage]}
                    src={sport}
                    alt="Login Illustration"
                    className="w-full object-cover transition-all duration-500 ease-in-out transform"
                />
            </div>

            {/* <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-20">
                {images.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentImage(index)}
                        className={`h-2  transition-all duration-300 ${index === currentImage
                            ? "w-8 bg-[#2BACE2]"
                            : "w-2 bg-white/50 hover:bg-white/80"
                            }`}
                    />
                ))}
            </div> */}
        </div>
    );
}
